import { gql } from '@apollo/client'
import { SCORE_FRAGMENT } from './ScoreFragments'

export const SIMPLE_AUDIT_FRAGMENT = gql`
  fragment SimpleAudit on Audit {
    id
    created
    saved
    dateCompleted
    displaysCompletedAt
    pricingCompletedAt
    surveyCompletedAt
    employee {
      firstName
      lastName
      id
      email
    }
    store {
      id
      storeChain
      name
      hasAllFormulas
      address {
        address1
        city
        state
        postalCode
      }
    }
    status
    score {
      created
      modified
      id
      total {
        ...Score
      }
    }
    notes
  }
  ${SCORE_FRAGMENT}
`
